<script>
  // export let elementName
  // export let variant
  // export let config

  // export let id
  // export let label
  // export let info
</script>

<svg stroke="currentColor" fill="none" viewBox="0 0 48 48">
  <path
    d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
<p>
  <slot inputClass="" />
  or drag and drop PNG, JPG, GIF up to 10MB
</p>
